var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { livequeueConsultationService } from 'ziphy-web-shared/basic/api';
import { isEqualIds } from 'ziphy-web-shared/basic/helpers';
import { useLoader, useParsedParams } from 'ziphy-web-shared/basic/hooks';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import { useLoadAppointment } from '@core/src/pages/consultation/hooks/useLoadAppointment';
import { usePageErrorBoundary } from '@library/providers/PageProvider';
import { $psHistory, $psPatient, $psResources } from '@store';
export const useInitPsPatient = ({ callback } = {}) => {
    var _a;
    const errorBoundary = usePageErrorBoundary();
    const [consultation, setConsultation] = useState(null);
    const { loadAppointmentById } = useLoadAppointment();
    const params = useParsedParams();
    const { patientId, practiceId, categoryId } = params;
    const getConsultation = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c, _d;
        let consultationId = null;
        const backToUrl = $router.searchParams.get('backToUrl');
        if (!backToUrl || typeof backToUrl !== 'string') {
            return null;
        }
        const match = backToUrl.match(/^\/appointments\/(\d+)\/(\d+)$/);
        if (!match) {
            return null;
        }
        const [, appointmentIdFromUrl] = match;
        if (!appointmentIdFromUrl) {
            return null;
        }
        const appointmentData = yield loadAppointmentById(appointmentIdFromUrl);
        if ((_b = appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.appointment) === null || _b === void 0 ? void 0 : _b.liveqId) {
            consultationId = appointmentData.appointment.liveqId;
        }
        else {
            if ((_c = appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.appointment) === null || _c === void 0 ? void 0 : _c.parentAppointmentId) {
                const parentAppointmentData = yield loadAppointmentById(appointmentData.appointment.parentAppointmentId);
                if ((_d = parentAppointmentData === null || parentAppointmentData === void 0 ? void 0 : parentAppointmentData.appointment) === null || _d === void 0 ? void 0 : _d.liveqId) {
                    consultationId = parentAppointmentData.appointment.liveqId;
                }
            }
        }
        if (!consultationId) {
            return null;
        }
        const consultation = yield livequeueConsultationService.getConsultationById(consultationId);
        setConsultation(consultation);
    });
    const { isLoading, reload } = useLoader(() => __awaiter(void 0, void 0, void 0, function* () {
        var _e;
        if (!isEqualIds(patientId, (_e = $psPatient.demographics) === null || _e === void 0 ? void 0 : _e.zid)) {
            $psPatient.clear();
            $psResources.clear();
        }
        yield $psPatient.loadData();
        yield getConsultation();
        if (!$psPatient.demographics) {
            return errorBoundary.error();
        }
        if (typeof callback === 'function') {
            yield callback({ params, errorBoundary });
        }
        yield $psPatient.loadPractices();
    }), [patientId, practiceId]);
    useEffect(() => {
        $psHistory.clearSearch();
        $psHistory.SET_CATEGORY(categoryId);
        $psHistory.clearSubcategory();
        if (categoryId) {
            $psHistory.loadEvents();
        }
        else {
            $psPatient.loadData();
        }
    }, [categoryId]);
    const patient = $psPatient.patient;
    const TabComponent = $psHistory.category && ((_a = $psHistory.categoryConfig) === null || _a === void 0 ? void 0 : _a.component);
    return {
        isLoading,
        reload,
        patient,
        TabComponent,
        patientId,
        practiceId,
        categoryId,
        consultation,
    };
};
